import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class RevPashQuery extends UncubesQuery {
  projection = 'group_ticket_sales'

  cuts = []

  aggregates = [
    { kpi: 'group_open_time_hours', function: 'SUM' }
  ]

  limit = 25

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged) {
    super();
    this.cuts = [
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `group_ticket_line_date between '${dateStart}' and '${dateEnd}'` }];
    if (isManaged) {
      this.aggregates.push({ kpi: 'group_ticket_line_amount_managed', function: 'SUM' });
      this.aggregates.push({ kpi: 'group_point_of_sale_number_of_diners_managed', function: 'SUM' });
      this.aggregates.push({ kpi: 'group_point_of_sale_number_of_diners_managed', function: 'COUNT' });
    } else {
      this.aggregates.push({ kpi: 'group_ticket_line_amount', function: 'SUM' });
      this.aggregates.push({ kpi: 'group_point_of_sale_number_of_diners', function: 'SUM' });
      this.aggregates.push({ kpi: 'group_point_of_sale_number_of_diners', function: 'COUNT' });
    }
  }
}
